export default __webpack_public_path__ + "bff369c3d1f1a3a94f32cee272c9fefe.png";